import { useEffect } from "react";
import Auth from "./Auth";
import { LoadingWithHeader } from "../common/LoadingWithHeader";
import { NavigateFunction } from "react-router-dom";

interface Props {
  auth: Auth;
  navigate: NavigateFunction;
}

export function Logout({ auth, navigate }: Props) {
  useEffect(() => {
    console.log("Logging out...");
    auth.logout(navigate);
  }, [auth, navigate]);

  return <LoadingWithHeader message={"Du wirst abgemeldet..."} />;
}
